import { createFileRoute } from "@tanstack/react-router";

import { UsersPage } from "@onesolution/pages";
import { protectSidebarRoute } from "@onesolution/utils";

export const Route = createFileRoute("/app/_layout/users")({
	beforeLoad: protectSidebarRoute("/app/users"),
	component: UsersPage,
});
